import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import L from 'leaflet';
// Components
import { MapContainer, TileLayer } from 'react-leaflet';

const mapUrlTemplate = `https://api.mapbox.com/styles/v1/${process.env.REACT_APP_MAPBOX_USERID}/${process.env.REACT_APP_MAPBOX_STYLEID}/tiles/256/{z}/{x}/{y}@2x?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`;

const mapAttribution =
  'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';

const markerOptions = {
  iconUrl: `${process.env.PUBLIC_URL}/icon-location.svg`,
  iconSize: [46, 56],
  iconAnchor: [23, 56],
};

const rijksmuseum = [52.3600009, 4.8830301];

const Wrapper = styled.div`
  height: 100%;

  .leaflet-container {
    height: 100vh;
    width: 100vw;
    z-index: 0;

    @media (min-width: 768px) {
      height: 100%;
      width: 100%;
    }
  }
`;

function Map({ position = rijksmuseum, zoom = 13 }) {
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (!map) return;

    // Reset map -> remove markers
    map.eachLayer((layer = {}) => {
      const { _url } = layer;

      // Only the map itself has a _url property
      // Markers don't have it
      if (!_url) {
        map.removeLayer(layer);
      }
    });

    // Center map to position
    map.setView(position, zoom);

    // Add marker to position
    var icon = L.icon(markerOptions);
    L.marker(position, { icon }).addTo(map);
  }, [map, position, zoom]);

  return (
    <Wrapper>
      <MapContainer
        center={position}
        zoom={zoom}
        scrollWheelZoom={true}
        whenCreated={setMap}
      >
        <TileLayer url={mapUrlTemplate} attribution={mapAttribution} />
      </MapContainer>
    </Wrapper>
  );
}

Map.propTypes = {
  position: PropTypes.arrayOf(PropTypes.number),
  zoom: PropTypes.number,
};

export default Map;
